App.Models.server_va = class server_va extends PF.Model {

    init() {
        super.init();

        this.calc('statusColor', ['status'], (d) => {
            let statuses = {
                default: 'inherit',
                set: 'blue',
                off: 'inherit',
                200: 'green',
                400: 'orange',
                500: 'red',
                0: 'red',
            };
            if (statuses[d]) {
                return statuses[d];
            } else {
                return 'red';
            }
        });
        
        this.calc('statusFormatted', ['status'], (d) => {
            let statuses = {
                default: 'Ожидается проверка',
                set: '',
                off: '',
                200: 'OK',
                400: 'На стеле обнаружены ошибки',
                500: 'Не отвечает',
                0: 'Не отвечает',
            };
            if (statuses[d]) {
                return statuses[d];
            } else {
                return '';
            }
        });

        this.calc('presetIslands', ['status'], (d) => {
            let statuses = {
                default: 'islands#grayCircleDotIcon',
                off: 'islands#grayCircleDotIcon',
                set: 'islands#blueCircleDotIcon',
                200: 'islands#greenCircleDotIcon',
                400: 'islands#yellowCircleDotIcon',
                500: 'islands#redCircleDotIcon',
                0: 'islands#redCircleDotIcon',
            };
            if (statuses[d]) {
                return statuses[d];
            } else {
                return 'islands#grayCircleDotIcon';
            }
        });

    }


};